import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { ChangePasswordDTO } from '@ridango/core';

import { Observable } from 'rxjs';

import { ChangePasswordActions } from './change-password.actions';
import * as ChangePasswordSelector from './change-password.selector';

@Injectable()
export class ChangePasswordFacade {
    loading$: Observable<boolean> = this.store.select(ChangePasswordSelector.getLoading);
    error$: Observable<any> = this.store.select(ChangePasswordSelector.getError);
    done$: Observable<boolean> = this.store.select(ChangePasswordSelector.getDone);
    isSubmitted$: Observable<boolean> = this.store.select(ChangePasswordSelector.getIsSubmitted);

    constructor(private store: NgRedux<any>, private actions: ChangePasswordActions) {}

    getNewPassword() {
        this.store.dispatch(this.actions.getNewPassword());
    }

    setNewPassword(setDTO: ChangePasswordDTO) {
        this.store.dispatch(this.actions.setNewPassword(setDTO));
    }
}
